// Generated by Argon compiler — do not edit by hand.
// CSR store output: reactive shared state with no runtime dependency.

const __argonSubs = new Map();

function __argonNotify(key) {
  for (const fn of __argonSubs.get(key) ?? []) fn();
}

export function argonSubscribe(key, fn) {
  let set = __argonSubs.get(key);
  if (!set) __argonSubs.set(key, set = new Set());
  set.add(fn);
  return () => {
    set.delete(fn);
    if (set.size === 0) __argonSubs.delete(key);
  };
}

export const settings = {};
let __argon_settings_open = false;
Object.defineProperty(settings, "open", {
  enumerable: true,
  get() { return __argon_settings_open; },
  set(value) {
    if (Object.is(__argon_settings_open, value)) return;
    __argon_settings_open = value;
    __argonNotify("settings.open");
  },
});

let __argon_settings_activeSection = "personal";
Object.defineProperty(settings, "activeSection", {
  enumerable: true,
  get() { return __argon_settings_activeSection; },
  set(value) {
    if (Object.is(__argon_settings_activeSection, value)) return;
    __argon_settings_activeSection = value;
    __argonNotify("settings.activeSection");
  },
});

let __argon_settings_notice = "";
Object.defineProperty(settings, "notice", {
  enumerable: true,
  get() { return __argon_settings_notice; },
  set(value) {
    if (Object.is(__argon_settings_notice, value)) return;
    __argon_settings_notice = value;
    __argonNotify("settings.notice");
  },
});

let __argon_settings_username = "";
Object.defineProperty(settings, "username", {
  enumerable: true,
  get() { return __argon_settings_username; },
  set(value) {
    if (Object.is(__argon_settings_username, value)) return;
    __argon_settings_username = value;
    __argonNotify("settings.username");
  },
});

let __argon_settings_fullName = "";
Object.defineProperty(settings, "fullName", {
  enumerable: true,
  get() { return __argon_settings_fullName; },
  set(value) {
    if (Object.is(__argon_settings_fullName, value)) return;
    __argon_settings_fullName = value;
    __argonNotify("settings.fullName");
  },
});

export function argonSnapshot() {
  return {
    settings: { open: settings.open, activeSection: settings.activeSection, notice: settings.notice, username: settings.username, fullName: settings.fullName },
  };
}

export function argonHydrate(snapshot) {
  if (!snapshot) return;
  if (snapshot.settings) {
    if ("open" in snapshot.settings) settings.open = snapshot.settings.open;
    if ("activeSection" in snapshot.settings) settings.activeSection = snapshot.settings.activeSection;
    if ("notice" in snapshot.settings) settings.notice = snapshot.settings.notice;
    if ("username" in snapshot.settings) settings.username = snapshot.settings.username;
    if ("fullName" in snapshot.settings) settings.fullName = snapshot.settings.fullName;
  }
}

const __argonPayload = globalThis.document?.querySelector?.('script[type="application/json"][data-argon-stores]');
if (__argonPayload?.textContent) argonHydrate(JSON.parse(__argonPayload.textContent));
